import { RequestModel } from "./RequestModel";
import { TechnicianModel } from "./TechnicianModel";
import { TaskClockModel } from "./TaskClockModel";
import { ContactModel } from "./ClientModel";
import { TaskNoteModel } from "./TaskNoteModel";

import Helper, { DateFormat } from "@/services/Helper";

class TaskModel
{
    constructor (obj?: TaskModel)
    {
        if (obj)
        {
            Object.assign(this, obj);

            // fix dates to local times ...
            if (obj.CreateDate)
            {
                let tmp = new Date((obj.CreateDate + "").split("T")[0] + " 00:00:00");
                this.CreateDate = tmp.toUTCString();
            }

            if (obj.CompleteByDate)
            {
                let tmp = new Date((obj.CompleteByDate + "").split("T")[0] + " 00:00:00");
                this.CompleteByDate = tmp.toUTCString();
            }

            if (obj.WorkCompleteDate)
            {
                let tmp = new Date((obj.WorkCompleteDate + "").split("T")[0] + " 00:00:00");
                this.WorkCompleteDate = tmp.toUTCString();
            }

            if (obj.Request)
            {
                this.Request = new RequestModel(obj.Request);
            }

            if (obj.Contact)
            {
                this.Contact = new ContactModel(obj.Contact);
                this.CustomerNumber = obj.Contact.CustomerNumber;
            }

            if (obj.Technician)
            {
                this.Technician = new TechnicianModel(obj.Technician);
            }

            if (obj.Clock)
            {
                this.Clock = new TaskClockModel(obj.Clock);
            }

            if (obj.Notes)
            {
                this.Notes = [];

                for (let i = 0; i < obj.Notes.length; i++)
                {
                    this.Notes.push(new TaskNoteModel(obj.Notes[i]));
                }
            }
        }
        else
        {
            // Set defaults for new records
            this._CreateDate = Helper.dateToInput(new Date(), DateFormat.Date);
            this._CompleteByDate = Helper.dateToInput(new Date(), DateFormat.Date);
        }
    }

    // Complex properties ...
    public Request?: RequestModel;
    
    public Contact?: ContactModel
    
    public Technician?: TechnicianModel;
    
    public Clock?: TaskClockModel;
    
    public Notes?: Array<TaskNoteModel>;

    // Simple properties ...
    public Id?: number | null;

    private _CreateDate?: string | null;

    public get CreateDate (): string | null
    {
        return Helper.dateToInput(this.CreateDateAsDate, DateFormat.Date) || null;
    }

    public set CreateDate (val: string | null)
    {
        this._CreateDate = val || null;
    }

    public get CreateDateAsDate (): Date | null
    {
        if (this._CreateDate)
        {
            return Helper.dateFromString(this._CreateDate) || null;
        }

        return null;
    }

    public WorkAssignment?: string | null;

    public EstimatedTime?: number | null;

    public _CompleteByDate?: string | null;

    public get CompleteByDate (): string | null
    {
        return Helper.dateToInput(this.CompleteByDateAsDate, DateFormat.Date) || null;
    }

    public set CompleteByDate (val: string | null)
    {
        this._CompleteByDate = val || null;
    }

    public get CompleteByDateAsDate (): Date | null
    {
        if (this._CompleteByDate)
        {
            return Helper.dateFromString(this._CompleteByDate) || null;
        }

        return null;
    }

    public ActualWork?: string | null;
    
    public ActualTime?: number | null;
    
    private _WorkCompleteDate?: string | null;

    public get WorkCompleteDate (): string | null
    {
        return Helper.dateToInput(this.WorkCompleteDateAsDate, DateFormat.Date) || null;
    }

    public set WorkCompleteDate (val: string | null)
    {
        this._WorkCompleteDate = val || null;
    }

    public get WorkCompleteDateAsDate (): Date | null
    {
        if (this._WorkCompleteDate)
        {
            return Helper.dateFromString(this._WorkCompleteDate) || null;
        }

        return null;
    }
    
    public AssignedTo?: number | null;
    
    public RequestId?: number | null;

    public CustomerNumber?: number | null;
    
    public InvoiceTime?: number | null;
    
    public InvoiceText?: string | null;
    
    public Status?: number | null;
    
    public CalendarId?: number | null;
    
    public SortOrder?: number | null;
    
    public TaskLocation?: string | null;
    
    public InvoiceAmount?: number | null;
    
    public ComplianceAssetId?: number | null;
    
    public ShouldBill?: number | null;
    
    public ActualOvertime?: number | null;
    
    public PaidAmount?: number | null;
    
    public Priority?: number | null;
    
    public WorkAssignmentLocation?: number | null;

    public WorkOrderId?: number | null;

    public WorkOrder?: any | null;

    public InvoiceNumber?: string | null;

    public Type?: string | null;

    public RecCount?:number | null;

}

class TimeModel extends TaskModel
{
    // ... alias
}

class TaskModelFilter 
{
    Id: Array<number> = [];

    RequestId: Array<number> = [];
    
    ContactId: Array<number> = [];
    
    TechId: Array<number> = [];
    
    ClockId: Array<string> = [];
    
    IncludeActiveClocks: boolean = false;
    
    IncludeRequest: boolean = false;
    
    IncludeContact: boolean = false;
    
    // TimeType filter: "All", "Assignments", "Work"
    TimeType: string = "All";
    
    StartDate:Date = new Date();
    
    EndDate:Date = new Date();
    
    Page:number = 0;
    
    Size:number = 25;
}

class TimeModelFilter extends TaskModelFilter
{
    // ... alias
}

export { TaskModel, TimeModel, TaskModelFilter, TimeModelFilter }